import {
  Typography,
  ListItem,
  ListItemPrefix,
  Radio
} from '@material-tailwind/react'

import PropTypes from 'prop-types'

export const ReportListItem = ({ id, label, active, icon: IconComponent, description, ...props }) => {
  const containerStyle = Object.freeze({
    true: 'border border-blue-400 bg-blue-50 focus:bg-blue-50 hover:bg-blue-100',
    false: 'border'
  })

  const labelStyle = Object.freeze({
    true: 'font-medium text-blue-700',
    false: 'font-medium text-black'
  })

  const descriptionStyle = Object.freeze({
    true: 'text-blue-600',
    false: 'text-blue-gray-700'
  })

  const iconStyle = Object.freeze({
    true: 'text-blue-700',
    false: ''
  })
  return (
    <ListItem className={containerStyle[active]}>
      <label
        htmlFor={id}
        className="flex justify-between w-full cursor-pointer items-center px-3 py-2"
      >
        <div className='flex gap-4 items-center'>
          <IconComponent size='1.3rem' className={iconStyle[active]} />
          <div className='flex flex-col'>
            <Typography
              className={labelStyle[active]}
            >
              {label}
            </Typography>

            <Typography
              className={descriptionStyle[active]}
            >
              {description}
            </Typography>
          </div>
        </div>

        <ListItemPrefix className="mr-3">
          <Radio
            id={id}
            ripple={false}
            className="hover:before:opacity-0"
            {...props}
            containerProps={{
              className: 'p-0'
            }}
          />
        </ListItemPrefix>
      </label>
    </ListItem>
  )
}

ReportListItem.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  label: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.elementType,
  active: PropTypes.bool
}
